import styled from 'styled-components'
import above from '@/utils/above'
import getColumnSize from '@/utils/getColumnSize'
import * as UI from '@/components/UI'

export const Section = styled.section`
  margin-bottom: 6rem;
  position: relative;
  z-index: 20;
  ${above('md')`
    margin-bottom: 7.5rem;
  `}
`

export const Grid = styled(UI.Grid)`
  align-items: stretch;
  height: 100%;
`

export const Cell = styled.div`
  height: auto;
  width: ${getColumnSize(12)};
  padding-top: 1rem;

  ${above('md')`
    width: ${getColumnSize(6)};
    padding-top: 2rem;
  `}
  ${above('lg')`
    width: ${getColumnSize(4)};
    paddint-top: 2rem;
  `}
  ${above('xg')`
    width: ${getColumnSize(3)};
    padding-top: 0;
  `}
`
